module.exports = __webpack_public_path__ + "media/components/Sponsors/Projects/Show/Evaluation/emptyStar-54871b41f539bdbc708083ad035b2f87.svg";